<template lang="pug">
div
  #sidebarContent.contentSidebar(:class="{'sidebar-close': isSidebarClosed}")
    slot(name="panel" v-if="!isSidebarClosed")
    #toggleSidePanelResponsive.button-toggle-sidebar(@click="toggleSidebar" :class="hideResponsive")
      i.fas.fa-times
  .contentPrime
    #toggleSidePanel.button-toggle-sidebar(@click="toggleSidebar")
      i.fas.fa-chevron-left
    slot(name="content")
</template>

<script>
export default {
  name: "layout-collapsable-panel-vue",
  data() {
    return {
      isSidebarClosed: window.innerWidth < 1080,
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarClosed = !this.isSidebarClosed;
    },
    handleResize() {
      this.isSidebarClosed = window.innerWidth < 1080;
    }
  },
  computed: {
    hideResponsive() {
      return this.isSidebarClosed ? "d-none" : "";
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
